<template>
  <div class="broker-details">
    <Snapshot />
    <BrokerList class="broker-holding-list" />
  </div>
</template>

<script>
import Snapshot from '@/components/bidask/Snapshot.vue'
import BrokerList from '@/components/bidask/brokers/BrokerList.vue'
export default {
  components: { Snapshot, BrokerList }
}
</script>

<style lang="scss" scoped>
.broker-details {
  background: var(--bg-color-2);
  .broker-holding-list {
    padding: 0 15px;
  }
}
</style>
